import React, { useEffect } from 'react'
import CardViewSortition from '../sortition/CardViewSortition';
import CardView from '../cardView';
import DivTable from '../DivTable';
import InnerTable from '../Table';

const RenderTable = ({ columns, options, hasSorting, handleChange, dataList, setDataListFromItem,
    customProps, theme, divTable, dataListToDisplay, setPageNumber, isDynamicColumns, exportDataModel, customCardView }) => {
    const [isMobileSize, setIsMobileSize] = React.useState(false)

    React.useEffect(() => {

        window.onresize = windowResize;
        windowResize()
    }, [])

    const windowResize = () => {
        if (window.outerWidth > 1000) {
            setIsMobileSize(false)
        } else {
            setIsMobileSize(true)

        }
    }
    useEffect(() => {
        if (dataList?.pageNumber) {
            setPageNumber(dataList?.pageNumber)
            handleChange({ pageNumber: dataList?.pageNumber })
        }
    }, [dataList])
    return (
        <>

            {isMobileSize ? <>
                <CardViewSortition
                    columns={columns}
                    options={options}
                    hasSorting={hasSorting}
                    setSortText={handleChange} />

                {dataList?.data && !customCardView ? <CardView
                    dataList={dataList.data}
                    dataListToDisplay={dataListToDisplay?.length > 0 ? dataListToDisplay : dataList?.data}
                    columns={columns}
                    setDataListFromItem={setDataListFromItem}
                    customProps={customProps}
                    theme={theme}
                // options={options}
                /> : dataList?.data && customCardView ? <div className='card-view-container' id="gsfTable">
                    {customCardView({
                        dataList: dataList.data,
                        dataListToDisplay: dataListToDisplay?.length > 0 ? dataListToDisplay : dataList?.data,
                        columns: columns,
                        setDataListFromItem: setDataListFromItem,
                        customProps: customProps
                    })}
                </div> : '****'}
            </> : <>
                {divTable === true ?
                    <DivTable
                        columns={columns}
                        options={options}
                        hasSorting={hasSorting}
                        handleChange={handleChange}
                        dataList={dataList}
                        setDataListFromItem={setDataListFromItem}
                        dataListToDisplay={dataListToDisplay.length > 0 ? dataListToDisplay : dataList.data}
                        theme={theme}
                        customProps={customProps} />

                    : <InnerTable
                        columns={columns}
                        options={options}
                        hasSorting={hasSorting}
                        handleChange={handleChange}
                        dataListToDisplay={dataListToDisplay.length > 0 ? dataListToDisplay : dataList.data}
                        dataList={dataList}
                        setDataListFromItem={setDataListFromItem}
                        customProps={customProps}
                        isDynamicColumns={isDynamicColumns}
                        exportDataModel={exportDataModel}

                    />}
            </>}

        </>
    )
}

export default RenderTable
